import React from 'react';

import HiringPostCard from './HiringPostCard';
import JobCard from './JobCard';
import AggregateJobCard from './AggregateJobCard';

export const HIRING_POST_JOB = 'HiringPost';
export const GIG_JOB = 'Gig';
export const SINGLE_GIG_JOB = 1;

const JobCardRenderer = props => {
  const { job } = props;

  if (job?.type === HIRING_POST_JOB) {
    return (
      <HiringPostCard
        publicId={job?.public_id}
        title={job?.title}
        helperType={job?.helper_type}
        avatar={job?.poster?.avatar}
        posterName={job?.poster?.name}
        schedule={job?.timing}
        salary={job?.fee}
        location={job?.location}
        employmentType={job?.employment_type}
        postedAt={job?.posted_at}
        isCard
        fullWidth
      />
    );
  }

  if (job?.type === GIG_JOB && job?.jobs_count === SINGLE_GIG_JOB) {
    return (
      <JobCard
        timing={job?.timing}
        helperType={job?.helper_type}
        fee={job?.fee}
        publicId={job?.public_id}
        postedAt={job?.posted_at}
        posterName={job?.poster?.name}
        location={job?.location}
        avatar={job?.poster?.avatar}
        isCard
        fullWidth
      />
    );
  }

  return (
    <AggregateJobCard
      posterId={job?.poster?.id}
      totalJobs={job?.jobs_count}
      helperType={job?.helper_type}
      avatar={job?.poster?.avatar}
      posterName={job?.poster?.name}
      fee={job?.fee}
      location={job?.location}
      shifts={job?.timing}
      isCard
      fullWidth
    />
  );
};

export default JobCardRenderer;
